import service from '@/store/services/reports-service';

const state = {
    reportDownloads: [],
};

const mutations = {
    SET_RESOURCE_REPORT_DOWNLOADS: (state, reportDownloads) => {
        state.reportDownloads = reportDownloads;
    }
};

const actions = {
    downloads({commit, dispatch}, params) {
        return service.downloads(params)
            .then((downloads) => {
                commit('SET_RESOURCE_REPORT_DOWNLOADS', downloads);
            });
    }
};

const getters = {
    downloads: state => state.reportDownloads,
    meta: state => state.meta,
};

const reports = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default reports;
